import { Dropdown as DropdownAdminUI } from '@vtex/admin-ui';
import { useDropdown } from './use-dropdown.hook';

export type DropdownProps = {
  options: number[];
  initialSelectedOption: number;
  label?: string;
  onChange: (selectedOption: number | null) => void;
};

export const Dropdown = (props: DropdownProps) => {
  const { state } = useDropdown(props);

  return (
    <DropdownAdminUI
      variant="tertiary"
      items={props.options}
      state={state}
      label={props?.label ?? ''}
    />
  );
};
